<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>视频融合系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>视频融合系统</h2>
          <p>视频融合系统基于网络的视频融合将原有分散的、标准不同的各类监控设备、监控平台集中统一管理。依托分布式集群级联架构，可在互联网架构下实现百万级别各类视频设备接入，支持百万级别监控视频并发用户访问。能够广泛地应用于门户、微信、景区监控大屏等业务系统中，提供诸如实时观景、路况查询、景区导览、区域监控等监控功能。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>集中管理</h2>
          <p>将原有分散的、标准不同的各类监控设备、监控平台集中统一管理</p>
        </li>
        <li>
          <h2>实时监控</h2>
          <p>景区实时监控视频在景区监控中心大屏中显示，景区运营人员实时了解景区客流、车流等信息</p>
        </li>
        <li>
          <h2>景区直播</h2>
          <p>将景区实时游览、路况信息、景区导览等监控视频在微信、景区门户等系统中进行展示，游客可实时了解景区游览情况，合理安排游览时间</p>
        </li>
        <li>
          <h2>旅游安全保障</h2>
          <p>安全事件发生时，运营人员可根据监控视频得知事件发生具体位置，并及时调度相关部安排处理，保障游客安全。</p>
        </li>
        <li>
          <h2>提升旅游体验</h2>
          <p>实时了解景区各个景点的客流情况，并利用广播提醒游客合理安排游览路程规划，提升游览体验。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'videofusionSystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
